import React, { Component } from 'react'
import { connect } from 'react-redux';
import 'src/Containers/Support/ProductUpdates/styles.scss';
import {
    loadProductUpdate, loadProductUpdateSuccess
  } from 'src/Actions/Support/supportActions';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { PulseLoader } from 'react-spinners';
import { LanguageForCode } from 'src/Utils';

  class ProductUpdate extends Component {
   
    constructor(props) {
       
        super(props);
        this.state = {
            isLoading: false,
            productUpdateList:[],
            productUpdateListValue:[],
          prevLanguage: localStorage.getItem('activeLanguageCountry') ? localStorage.getItem('activeLanguageCountry').split("/")[0] : ''
        }
        this.isAuthorized = this.props.isAuthorized;
      }
  componentDidMount() {
    window.scrollTo(0, 0);
    if(this.isAuthorized){
      const authLang = LanguageForCode(localStorage.getItem('authLang')) 
      this.props.loadProductUpdate(authLang);
    }
    else{
      this.props.loadProductUpdate(localStorage.getItem('activeLanguageCountry').split("/")[0]);
    }
  }

  componentDidUpdate(){
    if(!this.isAuthorized)
    {
      if(this.state.prevLanguage != localStorage.getItem('activeLanguageCountry').split("/")[0])
      {
        this.props.loadProductUpdate(localStorage.getItem('activeLanguageCountry').split("/")[0]);
        this.setState({prevLanguage:localStorage.getItem('activeLanguageCountry').split("/")[0]});
      }
    }
  }
 
  renderQA = pList => {
    let { productUpdateList} = this.props.support;
    return (
      <>
        {productUpdateList && productUpdateList.length > 0 && productUpdateList.map((ob, i) => {
          return (
            <div className="product-info" key={ob.id}>
                 <hr className="separator" />
              <h2 className='product-date' >{new moment(ob.date).format("MMMM DD, YYYY")}</h2> 
              <h2 className='product-title' >{ob.title}</h2> 
              <h2 className='product-description'>{ob.description}</h2><br></br> 
            
            </div>
          )
        })}
      </>
    )
  }

  render() { 
    let { pList } = this.state;
    const { t } = this.props;
    return (
      <>
      {this.props.generic.initialLoad ? <div className='init-loader'>
          <PulseLoader color={'#ffffff'} style={{ marginBottom: 24, marginTop: 24 }} />
        </div> :
        <div className="product-update-page-wrapper">
        <div className="product-updates-section">
        <div className="page-heading">{t('PU_Title')}</div>
        <div className="product-wrapper" >
        {this.renderQA(pList)}
        </div> 
      </div>
      </div>}
      </>
    )
  }
}

const mapStateToProps = ({ support,generic }) => ({
    support,
    generic
  });

export const mapDispatchToProps = (dispatch) => ({
    
    loadProductUpdate: (language) => dispatch(loadProductUpdate(language)),
    loadProductUpdateSuccess: (list) => dispatch(loadProductUpdateSuccess(list)),
  });
  
  export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ProductUpdate));


